import * as actionType from '../const/actionsTypes';

const authReducer = (state = { authData: null }, action) => {
    switch (action.type) {
        case actionType.AUTH: {
            let normalizedData = action?.data;
            if (normalizedData && !normalizedData.result && (normalizedData._id || normalizedData.email)) {
                normalizedData = { result: normalizedData, ...normalizedData };
            }
            // Save the full API response exactly as returned
            localStorage.setItem('user_info', JSON.stringify(normalizedData));
            return { ...state, authData: normalizedData };
        }

        case actionType.LOGOUT:
            localStorage.removeItem('user_info');
            localStorage.removeItem('authData');
            localStorage.removeItem('paidTests');
            localStorage.removeItem('isPaidUser');
            localStorage.removeItem('userPackage');
            return { ...state, authData: null };

        default:
            return state;
    }
};

export default authReducer;


